import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Button from '../../../elements/Button';
import Box from '../../../elements/Box';
import LocationSelectorFilter from '../../../controls/LocationSelector/LocationSelector';
import Checkbox from '../../../elements/Checkbox';

const Footer = (props) => {
  const { callToAction, onClick, disabled } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  const getOptions = (options) => {
    return options.map((val) => ({
      label: translate(val.name, val.name),
      value: val.value,
      key: val.key
    }));
  };
  return (
    <Box
      position="absolute"
      bottom="0"
      width="100"
      paddingWidth="2"
      paddingBottom="2"
      style={style}
      className={`${className} fr-dates-range-selector-footer`}
      dataTestId="datesRangeSelectorFooter"
      bgColor="white"
    >
      {props.enableFlexibleDates && (
        <Box {...props.footerContainerComponent}>
          <Checkbox
            {...props.footerCheckboxComponent}
            className="custom-checkbox"
            isChecked={props.isCheckedFlexibleDates}
            onChange={() => {
              props.handleIsCheckedFlexibleDatesChange(!props.isCheckedFlexibleDates);
            }}
            label={translate('cmp-dates-picker-mobile-label-flexible-dates', 'Flexible dates')}
          />
          <LocationSelectorFilter
            selectMode={true}
            showSelectorMenuArrow={false}
            {...props.footerSelectComponent}
            defaultValue={props.flexibleDatesValues}
            options={getOptions(props.flexibleDatesRangeValues)}
            dataTestId="locationSelector-flexibleDates"
            placeholder={translate(
              'cmp-location-flexibles-dates-placeholder',
              'Select Flexibles Dates'
            )}
            onChange={(e) => {
              props.handleFlexibleDatesChange(parseInt(e.value));
            }}
            labelKey="flexiblesDates"
            ariaLabel={translate(
              'cmp-date-selector-aria-description',
              'Selector of flexible dates'
            )}
          />
          <div
            style={{
              display: 'flex',
              marginLeft: 'auto'
            }}
          >
            <Button
              onClick={props.clear}
              disabled={
                props.selectTo === null
                  ? props.selectFrom === undefined
                  : props.selectFrom === undefined && props.selectTo === undefined
              }
              {...props.footerClearButtonComponent}
            >
              {translate('cmp-dates-range-selector-mobile-clear-button', 'Clear')}
            </Button>
            <Button
              {...props.footerDoneButtonComponent}
              disabled={
                props.selectTo === null
                  ? props.selectFrom === undefined
                  : props.selectFrom === undefined && props.selectTo === undefined
              }
              onClick={onClick}
            >
              {translate('cmp-dates-range-selector-mobile-done-button', 'Done')}
            </Button>
          </div>
        </Box>
      )}
      {!props.enableFlexibleDates && (
        <Button
          width="100"
          rounded="0"
          color="dark"
          textTransform="uppercase"
          onClick={onClick}
          disabled={disabled}
          {...callToAction}
        >
          {translate('cmp-dates-range-selector-mobile-call-to-action', 'Select these days')}
        </Button>
      )}
    </Box>
  );
};

Footer.propTypes = {
  /**
   * settings of callToAction
   */
  callToAction: PropTypes.objectOf(PropTypes.any),
  /**
   * function fired when onClick
   */
  onClick: PropTypes.func,
  /**
   * determine if the button is disabled
   */
  disabled: PropTypes.bool,
  clear: PropTypes.func,
  enableFlexibleDates: PropTypes.bool,
  flexibleDatesRangeValues: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      key: PropTypes.string
    })
  ),
  handleFlexibleDatesChange: PropTypes.func,
  flexibleDatesValues: PropTypes.number,
  handleIsCheckedFlexibleDatesChange: PropTypes.func,
  isCheckedFlexibleDates: PropTypes.bool,
  footerCheckboxComponent: PropTypes.objectOf(PropTypes.any),
  footerContainerComponent: PropTypes.objectOf(PropTypes.any),
  footerSelectComponent: PropTypes.objectOf(PropTypes.any),
  footerDoneButtonComponent: PropTypes.objectOf(PropTypes.any),
  footerClearButtonComponent: PropTypes.objectOf(PropTypes.any)
};

Footer.defaultProps = {
  disabled: false,
  callToAction: {},
  onClick: () => {},
  footerContainerComponent: {
    style: {
      display: 'flex'
    }
  }
};

export default Footer;
